import { render, staticRenderFns } from "./ProductRepair.vue?vue&type=template&id=4522899c&scoped=true&"
import script from "./ProductRepair.vue?vue&type=script&lang=js&"
export * from "./ProductRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522899c",
  null
  
)

export default component.exports